import React from 'react';
import { SelectInput, useRecordContext, useTranslate } from 'react-admin';

const StatusInput = ({ classes, source, ...props }) => {
    const record = useRecordContext();
    const translate = useTranslate();

    const choices = [
        { id: 'draft', name: translate('Draft') },
        { id: 'review', name: translate('Review') },
        { id: 'accepted', name: translate('Accepted') },
        { id: 'refused', name: translate('Refused') }
    ];

    return (
        <SelectInput source={source} choices={choices} record={record} {...props} />
    );
};

StatusInput.defaultProps = {
    source: 'status'
};

export default StatusInput;
